import { createRouter, createWebHistory } from 'vue-router'
import { getAuth } from '@/utils'
import store from '@/store'

const routes = [
  // { path: '/',       name: 'home',  component: () => import('@/views/HomeView.vue') },
  { path: '/', name: 'home', redirect: { name: 'dashboard', hash: '#overview' } },
  { path: '/dashboard', name: 'dashboard', alias: ['/home'], component: () => import('@/views/Analytics/ListView.vue') },
  { path: '/about',  name: 'about', component: () => import('../views/AboutView.vue') },
  { path: '/login',  name: 'login', component: () => import('@/views/Session/SignInView.vue') },
  { path: '/password', name: 'password', component: () => import('@/views/Session/PasswordView.vue') },
  { path: '/logout', name: 'logout', meta: { requiresAuth: true } },

  { path: '/providers',          name: 'providers',    component: () => import('@/views/Providers/ListView.vue') },
  { path: '/providers/new',      name: 'newProvider',  component: () => import('@/views/Providers/FormView.vue') },
  { path: '/providers/:id/edit', name: 'editProvider', component: () => import('@/views/Providers/FormView.vue') },

  { path: '/validators',          name: 'validators',    component: () => import('@/views/Validators/ListView.vue') },
  { path: '/validators/new',      name: 'newValidator',  component: () => import('@/views/Validators/FormView.vue') },
  { path: '/validators/:id/edit', name: 'editValidator', component: () => import('@/views/Validators/FormView.vue') },

  { path: '/system-settings', name: 'systemSettings', component: () => import('@/views/SystemSettings/ListView.vue') },
  { path: '/provider-apis-panel', name: 'providerApisPanel', component: () => import('@/views/ProviderHealth/ListView.vue') },
  { path: '/provider-report-audits', name: 'providerReportAudits', meta: { requiresMainAdminOrDeveloper: true }, component: () => import('@/views/ProviderReportAudits/ListView.vue') },
  { path: '/provider-verifications', name: 'providerVerifications', meta: { requiresMainAdminOrDeveloper: true }, component: () => import('@/views/ProviderVerifications/ListView.vue') },
  { path: '/tracking-dashboard', name: 'trackingDashboard', meta: { requiresDeveloper: true }, component: () => import('@/views/TrackingDashboard/ListView.vue') },
  { path: '/request-logs', name: 'requestLogs', meta: { requiresDeveloper: true }, component: () => import('@/views/RequestLogs/ListView.vue') },
  { path: '/agent', name: 'agent', meta: { requiresMainAdminOrDeveloper: true }, component: () => import('@/views/Agent/WorkspaceView.vue') },
  { path: '/main-admins', name: 'mainAdmins', meta: { requiresDeveloper: true }, component: () => import('@/views/MainAdmins/ListView.vue') },
  { path: '/ai-analytics', name: 'aiAnalytics', meta: { requiresDeveloper: true }, component: () => import('@/views/AiAnalytics/ListView.vue') },
  { path: '/old-shipments-report', name: 'oldShipmentsReport', component: () => import('@/views/OldShipmentsReport/ListView.vue') },
  { path: '/tenants',          name: 'tenants',    component: () => import('@/views/Tenants/ListView.vue') },
  { path: '/tenants/:id/edit', name: 'editTenant', component: () => import('@/views/Tenants/FormView.vue'), },
  { 
    path: '/tenants/:id', 
    component: () => import('@/views/Tenants/DetailsView.vue'),
    children: [
      { path: 'settings',      name: 'settings',      component: () => import('@/views/Settings/ListView.vue') },
      { path: 'carriers',      name: 'carriers',      component: () => import('@/views/Carriers/ListView.vue') },
      { path: 'email-dns',     name: 'emailDns',      component: () => import('@/views/Tenants/EmailDnsView.vue') },
      { path: 'transactions',  name: 'tenantTransactions', component: () => import('@/views/Tenants/TransactionsView.vue') },
    ]  
  },
  { path: '/support-tickets',     name: 'supportTickets',     component: () => import('@/views/SupportTickets/ListView.vue') },
  { path: '/support-tickets/:id', name: 'showSupportTicket', component: () => import('@/views/SupportTickets/ShowView.vue') },

  { path: '/notifications/compose', name: 'notificationsCompose', component: () => import('@/views/Notifications/ComposeView.vue') },

  { path: '/carriers/clone', name: 'cloneCarriers', component: () => import('@/views/Carriers/CloneView.vue') },
  {
    path: '/carriers/:id',
    component: () => import('@/views/Carriers/DetailsView.vue'),
    children: [
      { path: '',         name: 'services', component: () => import('@/views/Services/ListView.vue') },
      { path: 'services', name: 'services', component: () => import('@/views/Services/ListView.vue') },
    ]
  },
  // { path: '/shipments/new', name: 'newShipment', component: () => import('@/views/Shipments/CreateView.vue') },
  // { path: '/shipments/:shipment_id/parcels/new', name: 'newParcel', component: () => import('@/views/Parcels/CreateView.vue') },
  // { path: '/shipments/:shipment_id/rates', name: 'rates', component: () => import('@/views/Rates/ListView.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  if (['login', 'password'].includes(to.name)) { return true }

  const auth = getAuth()
  const hasToken = !!auth.token
  const isExpired = auth.expires_in && new Date(auth.expires_in) <= new Date()

  if (!hasToken || isExpired) {
    store.dispatch('logout')
    return { name: 'login' }
  }

  if (to.meta.requiresDeveloper && auth.user_type !== 'developer') {
    return { name: 'dashboard' }
  }

  if (to.meta.requiresMainAdminOrDeveloper && !['developer', 'main_admin'].includes(auth.user_type)) {
    return { name: 'dashboard' }
  }

  return true
})

export default router
